import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'app-ncp-faq',
  templateUrl: './ncp-faq.component.html'
})
export class NcpFAQComponent implements OnInit {
  chaturl = '';

  chatLive!: boolean;
  currentTime!: any;

  constructor(private datePipe: DatePipe) {
    this.chaturl = 'https://home-c29.incontact.com/incontact/chatclient/chatclient.aspx?poc=90279247-0e43-47e6-9586-026666c2277c&bu=4597186';
   }

  ngOnInit(): void {
    this.checkBusinessHours();
  }

  openChat() {
    window.open(this.chaturl, '', 'width=510, height=900');
  }

  checkBusinessHours() {
    var businessOpen = new Date();
    businessOpen.setHours(8, 0, 0); //8:00AM MST or 10:00AM EST
    this.datePipe.transform(businessOpen, 'EEEE h:mm:ss a zzzz', "GMT -6"); // Day Time Timezone
    //console.log("BUSINESS OPEN: ", businessOpen)

    var businessClose = new Date();
    businessClose.setHours(18, 0, 0); //6:00PM MST or 8:00PM EST
    this.datePipe.transform(businessClose, 'h:mm:ss a zzzz', "GMT -6"); // Day Time Timezone
    //console.log("BUSINESS CLOSE: ", businessClose)

    var currentTime = new Date();
    this.datePipe.transform(currentTime, 'EEEE h:mm:ss a zzzz', "GMT -6"); // Day Time Timezone
    //console.log("CURRENT TIME: ", currentTime);

    var currentDay = currentTime.toString().split(' ')[0];

    if (currentDay === "Sat" || currentDay === "Sun") {
      this.chatLive = false;
    }
    else {
      if (currentTime >= businessOpen && currentTime <= businessClose) {
        this.chatLive = true;
      }
      else {
        this.chatLive = false;
      }
    }
  }
}
